module.exports = __webpack_public_path__ + "img/box_pro_one_2.f527f7bf.jpg";